<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('SMTP')"
          :text="$t('smtp-info-text')"
          :btnText="$t('Add SMTP')"
          @action="openNewPopup" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            @click="openEditPopup(item.id)"
            class="list-table-item"
            v-for="(item, index) in get_smtps.items" :key="`item-${index}`">
            <div class="table-cell small">
              <Icon
                :circle=true
                name="server"
                size="20"/>
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.name}` }}
              </span>
                <span class="additional-info">{{ `${item.username}` }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      :showConfirmButton="!deleteSMTP"
      :showDeleteButton="deleteSMTP"
      @cancel="togglePopup"
      @deleteAction="deleteSMTPAction"
      @confirm="submitForm">
      <template v-slot:header>
        <h2 v-if="!isEdit">{{ $t('Add SMTP') }}</h2>
        <h2 v-if="isEdit">{{ $t('Edit SMTP') }}</h2>
      </template>
      <div>
        <div class="row">
          <InputSelect v-if="get_user.is_admin"
            class="col-xs-12 m-b-20"
            :multiSelect=true
            :preselected="form.accessible_for_subaccounts"
            :label="$t('accessible_for_accounts')"
            @change="selectAccessibleSubaccount"
            :rules="{required: true}"
            :options="getAllowedSubaccounts" />
          <InputText
            class="col-xs-12 m-b-20"
            :label="$t('name')"
            v-model="form.name"
            :rules="{required: true}" />
          <InputText
            class="col-xs-12 m-b-20"
            label="Host"
            v-model="form.host"
            :rules="{required: true}" />
          <InputText
            class="col-xs-12 m-b-20"
            :label="$t('username')"
            v-model="form.username" />
        </div>
        <div class="row m-b-20">
          <InputText
            class="col-xs-6"
            type="password"
            :label="$t('password')"
            v-model="form.password" />
          <InputText
            class="col-xs-6"
            label="Port"
            v-model="form.port"
            :rules="{required: true}" />
        </div>
        <div class="row">
          <div class="col-xs-12">
            <InputSelect
              :label="$t('security')"
              v-model="form.smtp_ssl"
              :options="selectOptions(get_smtps.entity['security'])" />
          </div>
        </div>
        <div class="separator medium" v-if="isEdit"></div>
        <div class="row">
          <div class="col-xs-12" v-if="isEdit">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('delete') }}</p>
                <span>{{ $t('SMTP will be deleted') }}</span>
              </div>
              <div>
                <Toggle color="red" id="deleteSmtp" v-model="deleteSMTP" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';

import InfoTextBox from '@/components/global/infoTextBox';
import formValidator from '@/mixins/formValidator';

export default {
  name: 'Smtp',
  mixins: [formValidator],
  components: {
    Btn,
    Popup,
    InputText,
    InputSelect,
    Toggle,
    InfoTextBox,
  },
  data() {
    return {
      openPopup: false,
      isEdit: false,
      smtpId: '',
      deleteSMTP: false,
      form: {
        accessible_for_subaccounts: [],
        name: '',
        host: '',
        username: '',
        password: '',
        port: '',
        smtp_ssl: '',
      },
    };
  },
  computed: {
    ...mapGetters([
      'get_smtps',
      'get_smtp_by_id',
      'get_subaccounts',
      'get_user'
    ]),
    isPopupSubmitDisabled() {
      if(this.get_user.is_admin && this.form.accessible_for_subaccounts.length == 0) return true;
      const formWithValidators = [
        {
          formFeild:'name',
          value: this.form.name,
          validators:{required: true}
        },
        {
          formFeild:'host',
          value: this.form.host,
          validators:{required: true}
        },
        {
          formFeild:'port',
          value: this.form.port,
          validators:{required: true}
        },
      ]

      return this.validateInput(formWithValidators);
    },
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
  },
  created() {
    this.$store.dispatch('GET_SMTPS');
  },
  methods: {
    selectAccessibleSubaccount(val) {
        this.form.accessible_for_subaccounts = val;
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: property });
      }
      return options;
    },
    clearLocalFormData() {
      this.form = {
        accessible_for_subaccounts: [],
        name: '',
        host: '',
        username: '',
        password: '',
        port: '',
        smtp_ssl: '',
      };
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.smtpId = '';
      this.clearLocalFormData();
    },
    submitForm() {
      const action = this.isEdit ? 'EDIT_SMTP' : 'SET_SMTP';

      this.form.accessible_for_subaccounts = this.form.accessible_for_subaccounts.filter((val) => this.get_user.accessible_subaccounts_array.indexOf(String(val)) > -1);

      this.$store.dispatch(`${action}`, {
        form: this.form,
        id: this.smtpId || '',
      }).then(() => {
        this.$store.dispatch('GET_SMTPS');
        this.openPopup = false;
        this.clearLocalFormData();
      });
    },
    openNewPopup() {
      this.isEdit = false;
      this.togglePopup();
    },
    openEditPopup(id) {
      this.togglePopup();
      this.isEdit = true;
      this.smtpId = id;
      this.form = { ...this.get_smtp_by_id(id) };
    },
    deleteSMTPAction() {
      this.$store.dispatch('DELETE_SMTP', this.smtpId).then(() => {
        this.$store.dispatch('GET_SMTPS');
        this.deleteSMTP = false;
        this.isEdit = false;
        this.togglePopup();
      });
    },
  },
};
</script>
